import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FileQuestion, Home, ArrowLeft } from 'lucide-react';
import { ErrorLayout } from './ErrorLayout';
import { Button } from '../common/Button';

/**
 * NotFoundPage Component (404)
 * 
 * Displays when user navigates to an invalid route.
 * 
 * Features:
 * - Clear messaging
 * - Navigation options (home, back)
 * - Dark mode compatible
 * - Mobile-first responsive
 * 
 * Industry Pattern: GitHub 404, Vercel 404
 * 
 * @component
 * @example
 * ```tsx
 * <Route path="*" element={<NotFoundPage />} />
 * ```
 * 
 * @returns {JSX.Element} Rendered 404 error page
 */
export const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <ErrorLayout
      title="404 - Page Not Found"
      description="The page you're looking for doesn't exist or has been moved."
      icon={<FileQuestion className="w-16 h-16" />}
      actions={
        <>
          <Button 
            variant="primary" 
            size="md"
            onClick={() => navigate('/')}
            icon={<Home className="w-4 h-4" />}
            iconPosition="left"
          >
            Go Home
          </Button>
          <Button 
            variant="secondary" 
            size="md"
            onClick={() => navigate(-1)}
            icon={<ArrowLeft className="w-4 h-4" />}
            iconPosition="left"
          >
            Go Back
          </Button>
        </>
      }
    />
  );
};

